import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { observer, inject } from 'mobx-react';
import { Caption } from '@xo-union/tk-ui-typography';
import RsvpDropdown from '~/glm/components/guest-list/header/rsvp-filter-dropdown';
import SelectDropdown from '~/glm/components/guest-list/header/select-dropdown';
import MissingInfoDropdown from '~/glm/components/guest-list/cells/missing-info-dropdown.jsx';
import GdsEventModel from '~/glm/models/gds/gds-event-model';
import RsvpMealsCombinedDropdown from '~/glm/components/guest-list/header/rsvp-meals-combined-dropdown';
import styles from './filter-guests-dropdown.scss';

@inject('gdsUiState')
@observer
class FilterGuestsDropDown extends React.Component {
  static propTypes = {
    rsvpFilter: PropTypes.func,
    mealFilter: PropTypes.func,
    event: PropTypes.instanceOf(GdsEventModel),
    gdsUiState: PropTypes.object,
    label: PropTypes.string,
  };

  state = {
    selectedFilterData: null,
    menuOpen: false,
  };

  setMenuState = bool => {
    if (typeof bool === 'boolean') {
      this.setState({ menuOpen: bool });
    } else {
      this.setState(state => ({
        menuOpen: !state.menuOpen,
      }));
    }
  };

  render() {
    const { rsvpFilter, event, mealFilter, gdsUiState, label } = this.props;
    const selectedFilterData = event.hasMeals() ? null : gdsUiState.rsvpFilter;
    return (
      <SelectDropdown setMenuState={this.setMenuState} label={label} {...this.state}>
        {event.hasMeals() ? (
          <RsvpMealsCombinedDropdown
            rsvpFilter={rsvpFilter}
            mealFilter={mealFilter}
            setSelectedFilterData={this.setSelectedFilterData}
            currentSelection={get(selectedFilterData, ['label'])}
            setMenuState={this.setMenuState}
            event={event}
            tabIndex={0}
          />
        ) : (
          <div className={styles.singleEventDropdown}>
            <Caption className={styles.sectionHeader}>RSVP Status</Caption>
            <RsvpDropdown showCheckmark rsvpFilter={rsvpFilter} currentSelection={selectedFilterData} border={false} />
            <Caption className={styles.sectionHeader}>Missing Info</Caption>
            <MissingInfoDropdown
              showCheckmark
              addressFilter={gdsUiState.addressFilter}
              gdsUiState={gdsUiState}
              border={false}
            />
          </div>
        )}
      </SelectDropdown>
    );
  }
}

export default FilterGuestsDropDown;
